import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { MisdeliveryNotesData, MdsNoteResponse } from "../models";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create ON Hand and return same object
 */

export const CreateMSDNotes = async (params: MisdeliveryNotesData): Promise<MdsNoteResponse> => {
  try {
    const response = await axios.post(getUrl(ApiType.MSD_NOTES), params);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.createMSDNotes, { badRequestOrder: "errorsFirst" });
  }
};
